import PropTypes from 'prop-types';
import { consts as CarouselConsts } from 'react-elastic-carousel';
import styled from 'styled-components';
import { position, space } from 'styled-system';

import { Button } from '@hivebrite/design-system/Button';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

import useDisplayBlurEffects from 'hb-react/shared/hooks/theme/useDisplayBlurEffects';

const IconAngleLeft = () => (
  <FontAwesomeIcon iconName="angle-left" iconType={CATEGORIES.REGULAR} />
);

const IconAngleRight = () => (
  <FontAwesomeIcon iconName="angle-right" iconType={CATEGORIES.REGULAR} />
);

const SliderArrow = ({
  type,
  onClick,
  isEdge,
  loading = false,
  leftArrowStyle,
  rightArrowStyle,
  ...otherProps
}) => {
  const displayBlurEffects = useDisplayBlurEffects();
  const isPrev = type === CarouselConsts.PREV;

  // don't show the buttons on edges
  if (isEdge) {
    return null;
  }

  if (isPrev) {
    return (
      <StyledButtonContainerPrev
        css={leftArrowStyle}
        $displayBlurEffects={displayBlurEffects}
        {...otherProps}
      >
        <StyledButton
          tabIndex={-1}
          aria-label={s__('Accessibility|Display previous results')}
          onClick={onClick}
          icon={IconAngleLeft}
          variant="inversed"
        />
      </StyledButtonContainerPrev>
    );
  }

  return (
    <StyledButtonContainerNext
      css={rightArrowStyle}
      $displayBlurEffects={displayBlurEffects}
      $isEdge={isEdge}
      {...otherProps}
    >
      <StyledButton
        tabIndex={-1}
        aria-label={s__('Accessibility|Display next results')}
        isDisabled={isEdge || loading}
        onClick={onClick}
        icon={IconAngleRight}
        variant="inversed"
      />
    </StyledButtonContainerNext>
  );
};

SliderArrow.propTypes = {
  type: PropTypes.oneOf([CarouselConsts.NEXT, CarouselConsts.PREV]),
  onClick: PropTypes.func,
  isEdge: PropTypes.bool,
  loading: PropTypes.bool,
};

export default SliderArrow;

const StyledButton = styled(Button)`
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  pointer-events: auto;
  border-radius: 20px !important;
  height: 40px;
  padding-left: 20px;
  padding-right: 20px;
`;

const StyledButtonContainer = styled.div.attrs(({ theme }) => ({
  pt: theme.grid.rowGap,
}))`
  top: 50%;
  margin-top: -8px;
  position: absolute;
  z-index: 100;
  ${position}
  ${space}
`;

const StyledButtonContainerPrev = styled(StyledButtonContainer).attrs(() => ({
  left: { _: '-12px', m: '4px' },
}))`
  ${({ $displayBlurEffects }) =>
    $displayBlurEffects ? '' : 'background: inherit !important;'}
`;

const StyledButtonContainerNext = styled(StyledButtonContainer).attrs(() => ({
  right: {
    _: -12,
    m: -20,
  },
}))`
  ${({ $isEdge }) => ($isEdge ? 'background-color: none;' : '')}
  ${({ $displayBlurEffects }) =>
    $displayBlurEffects ? '' : 'background: inherit !important;'}
`;
